export function isModalOpen(state: any, modalName: string) {
  return !!(state?.modal && state.modal[modalName]);
}

export function totalModalsOpen(state: any) {
  return state?.modal ? Object.keys(state.modal).length : 0;
}
